'use client';

export default function StructuredData({ type = 'organization' }) {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Conversion Growth',
    url: 'https://conversiongrowth.agency',
    logo: 'https://conversiongrowth.agency/images/logo-v2.png',
    description: 'Professional CRO and Data Analytics agency specializing in conversion rate optimization and revenue growth',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Shelton Street',
      addressLocality: 'Covent Garden',
      addressRegion: 'London',
      postalCode: 'WC2H 9JQ',
      addressCountry: 'GB'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@conversiongrowth.agency',
      contactType: 'Customer Service',
      availableLanguage: ['English', 'Arabic']
    },
    sameAs: [
      'https://www.linkedin.com/company/conversion-growth-agency',
      'https://twitter.com/conversiongrowth',
    ]
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Conversion Growth',
    url: 'https://conversiongrowth.agency',
    description: 'Transform your revenue with our CRO + Data Analytics services',
    publisher: {
      '@type': 'Organization',
      name: 'Conversion Growth',
    }
  };

  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Conversion Growth',
    image: 'https://conversiongrowth.agency/images/logo-v2.png',
    '@id': 'https://conversiongrowth.agency',
    url: 'https://conversiongrowth.agency',
    telephone: '',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Shelton Street',
      addressLocality: 'Covent Garden',
      addressRegion: 'London',
      postalCode: 'WC2H 9JQ',
      addressCountry: 'GB'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 51.5142,
      longitude: -0.1249
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday'
      ],
      opens: '09:00',
      closes: '18:00'
    },
    priceRange: '$$'
  };

  const aggregateSchema = {
    '@context': 'https://schema.org',
    '@graph': [organizationSchema, websiteSchema, serviceSchema]
  };

  return (
    <script data-component-id="src/components/common/StructuredData.jsx:85:4" data-component-path="src/components/common/StructuredData.jsx" data-component-line="85" data-component-file="StructuredData.jsx" data-component-name="script" data-component-content="%7B%22elementName%22%3A%22script%22%2C%22type%22%3A%22application%2Fld%2Bjson%22%7D"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(aggregateSchema) }}
    />
  );
}
